(function () {
    'use strict';

    var module = angular.module('app');

    module.constant('claimTypes', {
        'nameIdentifier': "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier",
        'emailAddress': "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
        'givenName': "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname",
        'surname': "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname",
        'role': "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
    });

    module.factory('currentUserService',
    [
        'authenticationTokenService', 'claimTypes',
        function (authenticationTokenService, claimTypes) {

            var getCurrentUser = function () {
                var decodedToken = authenticationTokenService.getDecodedToken();

                if (!decodedToken) return null;

                var claims = decodedToken.claims;

                return {
                    id: claims[claimTypes.nameIdentifier][0],
                    firstName: claims[claimTypes.givenName][0],
                    lastName: claims[claimTypes.surname][0],
                    roles: claims[claimTypes.role]
                };
            };

            var isInRole = function (role) {
                var currentUser = getCurrentUser();
                return currentUser && currentUser.roles.indexOf(role) !== -1;
            }

            var isInAnyRole = function (roles) {
                return _.some(roles, function (role) {
                    return isInRole(role);
                });
            }

            return {
                getCurrentUser: getCurrentUser,
                isInRole: isInRole,
                isInAnyRole: isInAnyRole
            };
        }
    ]);
}());